import { BranchData } from '@/common/types/cards/details.type'
import { MetaResponse } from '@/common/types/metaResponse'
import { MessageData } from '@/common/types/support/message.type'
import { UserData } from '@/common/types/users'

export type CreatorData = UserData;

export type TicketStatus = 'pending' | 'awaiting_customer_response' | 'awaiting_tcard_response' | 'closed'

export enum CreatorType {
  AdminUser = 'Admin::User',
  ClientUser = 'Client::User',
}

export type TicketData = {
  id: string
  branch: BranchData
  created_at: string
  creator: CreatorData
  creator_type: CreatorType;
  messages_count: number
  first_message: MessageData
  reason: {
    id: string
    description: string
    display_name: string
  }
  reference_number: string
  responsible: {
    id: string
    email: string
    full_name: string
    profile_picture: {
      id: string
      attachment_id: string
      content_type: string
      url: string
    }
  }
  status: TicketStatus
  subject_line: string
}

export type TicketsResponse = {
  data: {
    data: TicketData[]
    meta: MetaResponse
  }
}

export type TicketResponse = {
  data: {
    data: TicketData
  }
}

export type TicketDataTableItem = {
  reference_number: string
  status: any
  reason: string
  creator: any
  created_at: string
  actions: JSX.Element
}
